export default __webpack_public_path__ + "static/media/HistoricAddMotive.f100cb17.svg";